import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function Vision() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 px-6 bg-zinc-950" data-id="element-176">
      <div className="max-w-3xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-178">
          <p className="text-2xl md:text-4xl font-serif leading-snug text-zinc-200" data-id="element-179">
            {t('vision.p1')}
          </p>

          <div className="space-y-8 text-lg md:text-xl text-zinc-400 font-light leading-relaxed" data-id="element-180">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-181">
              {t('vision.p2')}
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-182">
              {t('vision.p3Start')}
              <span className="text-zinc-200 font-medium" data-id="element-183">
                {t('vision.p3Highlight')}
              </span>
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}